import { api } from './client'

// ---------- tipuri — oglindesc DTO-urile din Cipral.Application/Achizitii/CereriAchizitieModels.cs ----------

export type PurchaseRequestStatus = 'Draft' | 'PendingApproval' | 'Approved' | 'Rejected' | 'ConvertedToOrder'

export interface PurchaseRequestLine {
  id: string | null
  articleId: string
  articleCode: string
  articleDescription: string
  description: string | null
  quantityRequested: number
  unitOfMeasureId: string
  unitOfMeasureCode: string
  suggestedSupplierId: string | null
  suggestedSupplierName: string | null
}

export type SavePurchaseRequestLinePayload = Pick<
  PurchaseRequestLine, 'articleId' | 'description' | 'quantityRequested' | 'unitOfMeasureId' | 'suggestedSupplierId'
>

export interface PurchaseRequestListItem {
  id: string
  number: string
  requestedDate: string
  requestedByUserName: string
  department: string | null
  estimatedTotal: number
  currency: string
  status: PurchaseRequestStatus
}

export interface PurchaseRequestDetail {
  id: string
  number: string
  requestedDate: string
  requestedByUserId: string
  requestedByUserName: string
  department: string | null
  notes: string | null
  estimatedTotal: number
  currency: string
  status: PurchaseRequestStatus
  convertedToOrderId: string | null
  lines: PurchaseRequestLine[]
}

export interface SavePurchaseRequestPayload {
  requestedDate: string
  department: string | null
  notes: string | null
  estimatedTotal: number
  currency: string
  lines: SavePurchaseRequestLinePayload[]
}

export interface ConvertPurchaseRequestToOrderPayload {
  supplierId: string
  deliveryWarehouseId: string
  requestedDeliveryDate: string
  paymentTerms: string | null
}

export const listPurchaseRequests = () => api.get<PurchaseRequestListItem[]>('/achizitii/cereri').then((r) => r.data)
export const getPurchaseRequest = (id: string) => api.get<PurchaseRequestDetail>(`/achizitii/cereri/${id}`).then((r) => r.data)
export const createPurchaseRequest = (payload: SavePurchaseRequestPayload) =>
  api.post<{ id: string }>('/achizitii/cereri', payload).then((r) => r.data)
export const updatePurchaseRequest = (id: string, payload: SavePurchaseRequestPayload) => api.put(`/achizitii/cereri/${id}`, payload)
export const submitPurchaseRequestForApproval = (id: string) =>
  api.post<{ pendingApproval: boolean }>(`/achizitii/cereri/${id}/submit-aprobare`).then((r) => r.data)
export const convertPurchaseRequestToOrder = (id: string, payload: ConvertPurchaseRequestToOrderPayload) =>
  api.post<{ id: string }>(`/achizitii/cereri/${id}/converteste-in-comanda`, payload).then((r) => r.data)
